/**
 * Why a packet is being returned to the sender. primary owns this vocabulary — its export
 * endpoint picks the destination folder from the reason when no file path is supplied. Flow
 * references it in its packet-export block.
 */
export var ExternalDocumentPacketExportReason;
(function (ExternalDocumentPacketExportReason) {
    ExternalDocumentPacketExportReason["FailedMedicalNecessity"] = "FailedMedicalNecessity";
    ExternalDocumentPacketExportReason["OutOfScope"] = "OutOfScope";
})(ExternalDocumentPacketExportReason || (ExternalDocumentPacketExportReason = {}));
//# sourceMappingURL=exportReason.js.map